import { ROUTE_NAMES } from '@/to-fsd/shared/constants';
import { AtToastPlugin } from '@packages/aliftech-ui';
import { i18n } from '@/to-fsd/shared/lib/i18n';

const requireAuthToken = ({ next, to }) => {
  const checkAuth = localStorage.getItem('access_token');

  if (!checkAuth) {
    AtToastPlugin.error({
      title: i18n.global.t('app.loginAgainRequired'),
      duration: 7000,
    });
    return { name: ROUTE_NAMES.login, query: { from: to.fullPath } };
  }

  return next();
};

export default requireAuthToken;
